import { LitElement, html } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import '../components/ChatMention';

@customElement('realtime-chat')
export class RealtimeChat extends LitElement {
  createRenderRoot() { return this }
  @property() channelSlug = '';
  @state() messages = [];
  @state() scope = 'channel';

  render() {
    return html`
      <div class="card bg-base-300 p-4 h-[80vh] flex flex-col hidden">
        <div class="flex justify-between items-center mb-2">
          <h3 class="font-bold text-primary min-w-40">Community Chat</h3>
          <select class="select select-sm" @change=${e => this.scope = e.target.value}>
            <option value="global">Global</option>
            <option value="channel" selected>Channel</option>
          </select>
        </div>
        <div class="flex-1 overflow-y-auto space-y-2 mb-2">
          ${this.messages.map(msg => html`
            <div class="bg-base-100 p-2 rounded">
              <strong>${msg.user}</strong>: ${msg.text}
              ${msg.postId ? html`<chat-post-mention .postId=${msg.postId}></chat-post-mention>` : ''}
            </div>
          `)}
        </div>
        <div class="flex gap-2">
          <input class="input input-sm border-secondary text-gray-800 w-full" placeholder="Share awesome content..." />
          <button class="btn btn-sm btn-secondary">Send</button>
        </div>
      </div>
    `;
  }
}
